<template>
	<div id="nav">
		<b-container fluid>
			<b-row>
				<b-col md="2" align-self="start" class="navigation-userspace" v-if="isLoggedIn">
					<b-row>
						<b-col>
      						<h5><b-icon icon="person-fill" font-scale="1.5" shift-v="-2.5" class="mr-2"></b-icon>{{ username }}</h5>
					  </b-col>
					  <b-col v-if="shouldShowRemaining">
						  <h5 style="font-weight:bold;color:red"><b-icon icon="clock" font-scale="1.5" shift-v="-2.5" class="mr-2"></b-icon>{{ remainingTime }}</h5>
					  </b-col>
					</b-row>
      			</b-col>
				<b-col sm="1" align-self="center" id="item-main">
      				<a href="/">Helpline</a>
      			</b-col>
      			<b-col sm="1" v-if="isLoggedIn" align-self="center" id="item-forms">
      				<router-link to="/my-forms">Űrlapjaim</router-link>
      			</b-col>
      			<b-col v-if="isLoggedIn" align-self="center" class="text-right" id="item-logout">
      				<a id="logout" @click="logout" href="#">Kijelentkezés</a>
      			</b-col>
      		</b-row>
      	</b-container>
    </div>
</template>

<script>
	import jwtDecode from 'jwt-decode'
	import { DateTime, Duration } from 'luxon'

	export default {
		name: 'navigation',
		data() {
			return {
				remainingTime: '',
				shouldShowRemaining: false
			}
		},
		computed: {
			isLoggedIn: function() {
				return this.$store.state.username !== ''
			},
			username: function() {
				return this.$store.state.username
			}
		},
		mounted() {
			const that = this
			setInterval(function() {
				const timeToTokenEnd = that.getRemainingLoginTime()
				if (timeToTokenEnd > 180 || timeToTokenEnd == null)
					return

				that.shouldShowRemaining = true
				if (timeToTokenEnd <= 0) {
					that.remainingTime = 'LEJÁRT'
					that.$session.remove('token')
					that.$router.go()
					return
				}
				const remaining = Duration.fromMillis(timeToTokenEnd * 1000)
				that.remainingTime = remaining.toFormat('mm:ss')
			}, 1000)
		},
		methods: {
			logout(event) {
				this.$modal.show('dialog', {
					text: '<div class="text-center">Valóban ki akar jelentkezni?</div>',
					buttons: [
						{
							title: 'Igen',
							handler: () => { this.$session.remove('token'); this.$router.go() }
						},
						{
							title: 'Nem'
						}]
				})
			},
			getRemainingLoginTime() {
				if (this.$session.get('token') === undefined)
					return null
				const token = jwtDecode(this.$session.get('token'))				
				return token.exp - Math.round(DateTime.local().toSeconds()) 
			}
		}
	}
</script>

<style>
.navigation-userspace {
	border: 2px solid gray;
	background: rgba(141,115,245, 0.3)
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#logout {
	cursor: pointer;
}
</style>